import type Quill from 'quill'

function normalizeUrl(value: string): string {
    const trimmed = value.trim()
    if (/^(https?:\/\/|mailto:)/i.test(trimmed)) {
        return trimmed
    }
    return `https://${trimmed}`
}

/**
 * Custom Quill toolbar handler for the link button.
 *
 * Quill invokes toolbar handlers with `this` bound to the toolbar module, which exposes the
 * editor as `this.quill`. Using a prompt-based flow (instead of Quill's floating "snow" tooltip)
 * avoids the tooltip being clipped/hidden inside Bootstrap modals and works whether or not the
 * user has selected text first.
 */
export function quillLinkHandler(this: { quill: Quill }) {
    const quill = this.quill
    const range = quill.getSelection(true)

    const url = window.prompt('Enter the URL (e.g. https://docs.google.com/...)', 'https://')
    if (!url || !url.trim() || url.trim() === 'https://') {
        return
    }

    const normalizedUrl = normalizeUrl(url)

    if (range.length > 0) {
        quill.format('link', normalizedUrl)
        return
    }

    const text = window.prompt('Enter the text to display', normalizedUrl)
    const displayText = text && text.trim() ? text.trim() : normalizedUrl

    quill.insertText(range.index, displayText, 'link', normalizedUrl)
    quill.setSelection(range.index + displayText.length, 0)
}
